// extracted by mini-css-extract-plugin
export default {"content":"Video_content__OQS3P","ref":"Video_ref__D8BHq","parent":"Video_parent__p7sSl","video":"Video_video__PVRqb"};